import { css } from 'styled-components';

export const inputTextLarge = css`
  padding: 7px 11px;
  font-size: 16px;
  line-height: 1.5;
  border-radius: 8px;
`;
